import type {
  DeliveryAreaUpdateRequestType,
  DeliveryAreaUpdateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useDeliveryAreaUpdate = (deliveryAreaId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: DeliveryAreaUpdateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `delivery-area/${deliveryAreaId}`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data).data as DeliveryAreaUpdateResponseType,
      ),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Suppliers],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.CustomerZones],
      });
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.DeliveryArea,
          deliveryAreaId,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.DeliveryArea],
      });
    },
  });
};
